var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulkSmSspend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E37333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2727_15561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4499 7.04999L16.3994 7.75749L17.1064 12.7075L12.5104 17.3035C12.4167 17.3972 12.2895 17.4499 12.1569 17.4499C12.0243 17.4499 11.8972 17.3972 11.8034 17.3035L6.85342 12.3535C6.75969 12.2597 6.70703 12.1326 6.70703 12C6.70703 11.8674 6.75969 11.7403 6.85342 11.6465L11.4499 7.04999ZM12.8639 11.293C12.9568 11.3858 13.0671 11.4595 13.1884 11.5097C13.3097 11.5599 13.4398 11.5858 13.5711 11.5858C13.7024 11.5857 13.8325 11.5599 13.9538 11.5096C14.0751 11.4593 14.1853 11.3856 14.2782 11.2927C14.371 11.1999 14.4447 11.0896 14.4949 10.9683C14.5451 10.8469 14.571 10.7169 14.571 10.5856C14.5709 10.4542 14.545 10.3242 14.4948 10.2029C14.4445 10.0816 14.3708 9.97133 14.2779 9.87849C14.185 9.78564 14.0748 9.712 13.9535 9.66177C13.8321 9.61153 13.7021 9.58569 13.5707 9.58571C13.3055 9.58576 13.0512 9.69116 12.8637 9.87874C12.6762 10.0663 12.5709 10.3207 12.5709 10.5859C12.5709 10.8511 12.6764 11.1055 12.8639 11.293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2727_15561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkSmSspend);
export default __webpack_public_path__ + "static/media/bulkSMSspend.dcefbcdc597b05a99f41982c4551c6e9.svg";
export { ForwardRef as ReactComponent };